import IpubSelect from './src/main'
import IpubOption from './src/option'

/* istanbul ignore next */
IpubSelect.install = function(Vue) {
  Vue.component(IpubSelect.name, IpubSelect)
  Vue.component(IpubOption.name, IpubOption)
}

export default IpubSelect
